import React from 'react';
import { Route, Routes } from 'react-router-dom';
import AreaList from './AreaList';
import AreaForm from './AreaForm';

const AreaRoutes = () => {
  return (
    <Routes>
      <Route index element={<AreaList />} />
      <Route path="new" element={<AreaForm />} />
      <Route path="edit/:id" element={<AreaForm />} />
    </Routes>
  );
};

export default AreaRoutes; 